/**
 * Derive a stable slug value from a display label.
 *
 * Supports both Latin and Cyrillic characters.
 *
 * Examples:
 * "Communication Services" -> "communication-services"
 * "Конструкторское бюро" -> "конструкторское-бюро"
 * "Монтаж" -> "монтаж"
 */
export const toSlug = (label: string): string =>
  label
    .toLowerCase()
    .trim()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");